import { useTranslation } from "react-i18next";

import { Modal, ModalFooter, ModalImage } from "shared/components/Modals/Modal";

import styled from "./NewPhotoWizardModal.module.scss";

import image from "assets/shared/img/ic_attractive-safe.svg";

const NewWizardPhotoModal = ({ close, uploadPhoto, addPhotoLater }) => {
  const { t } = useTranslation("wizardNew");

  return (
    <Modal close={close} isAnimated bodyClass={styled.modal}>
      <ModalImage
        isCircle={true}
        customClass={styled.attractiveIcon}
        src={image}
      />
      <h3 className={styled.title}>{t("modal.title")}</h3>
      <p className={styled.text}>{t("modal.text")}</p>
      <ModalFooter customClass={styled.footer}>
        <button onClick={() => uploadPhoto()} className={styled.upload__button}>
          {t("modal.btnUpload")}
        </button>
        <button
          onClick={() => addPhotoLater()}
          className={styled.later__button}
        >
          {t("modal.btnLater")}
        </button>
      </ModalFooter>
    </Modal>
  );
};

export { NewWizardPhotoModal };
